
interface ILottoFlag {
    lotoId: number;
    name: string;
    FlagName: string;
}

const flagsMap: Record<number, ILottoFlag> = {
    6: {
        lotoId: 6,
        name: 'Greece Kino - 20/80|Grecia Kino - 20/80|Grčki Kino - 20/80|Grčki Kino - 20/80|',
        FlagName: 'GREECE'
    },
    8: {
        lotoId: 8,
        name: `Poland Multi Multi - 20/80|Polonia Multi Multi - 20/80|
            Poljska Multi Multi - 20/80|Poljska Multi Multi - 20/80`,
        FlagName: 'POLAND'
    },
    9: {
        lotoId: 9,
        name: 'Win For Life - 10/20|Win For Life - 10/20|Win For Life - 10/20|Win For Life - 10/20|',
        FlagName: 'ITALY'
    },
    10: {
        lotoId: 10,
        name: 'Finland Keno - 20/70|Finlanda Keno - 20/70|Finska - 20/70|Finska - 20/70',
        FlagName: 'FINLAND'
    },
    11: {
        lotoId: 11,
        name: 'France - 20/70|Franta Keno - 20/70|Francuska - 20/70|Francuska - 20/70',
        FlagName: 'FRANCE'
    },
    12: {
        lotoId: 12,
        name: 'Latvia - 20/62|Letonia Keno - 20/62|Latvia - 20/62|Latvia - 20/62',
        FlagName: 'LATVIA'
    },
    13: {
        lotoId: 13,
        name: 'New York Pick10 - 20/80|New York Pick10 - 20/80|New York Pick10 - 20/80|New York Pick10 - 20/80|',
        FlagName: 'USA'
    },
    14: {
        lotoId: 14,
        name: `Washington Daily Keno - 20/80|Washington Daily Keno - 20/80|
            Washington Daily Keno - 20/80|Washington Daily Keno - 20/80|`,
        FlagName: 'USA'
    },
    15: {
        lotoId: 15,
        name: 'Arizona Fantasy 5 - 5/41|Arizona Fantasy 5 - 5/41|Arizona Fantasy 5 - 5/41|Arizona Fantasy 5 - 5/41|',
        FlagName: 'USA'
    },
    16: {
        lotoId: 16,
        name: 'Arizona The Pick - 6/44|Arizona The Pick - 6/44|Arizona The Pick - 6/44|Arizona The Pick - 6/44|',
        FlagName: 'USA'
    },
    17: {
        lotoId: 17,
        name: 'Australia OZ Loto - 7/45|Australia OZ Loto - 7/45|Australia OZ Loto - 7/45|Australia OZ Loto - 7/45',
        FlagName: 'AUSTRALIA'
    },
    18: {
        lotoId: 18,
        name: 'Austria Loto - 6/45|Austria Loto - 6/45|Austria Loto - 6/45|Austria Loto - 6/45',
        FlagName: 'AUSTRIA'
    },
    19: {
        lotoId: 19,
        name: '|Belgia Loto - 6/45|||',
        FlagName: 'BELGIUM'
    },
    20: {
        lotoId: 20,
        name: '|Canada Atlantic Bucko - 5/41|||',
        FlagName: 'CANADA'
    },
    21: {
        lotoId: 21,
        name: '|Canada Loto - 6/49|||',
        FlagName: 'CANADA'
    },
    22: {
        lotoId: 22,
        name: '|Canada Max Loto - 7/49|||',
        FlagName: 'CANADA'
    },
    23: {
        lotoId: 23,
        name: '|Colorado Cash 5 - 5/32|||',
        FlagName: 'USA'
    },
    24: {
        lotoId: 24,
        name: '|Colorado Loto - 6/42|||',
        FlagName: 'USA'
    },
    25: {
        lotoId: 25,
        name: '|Connecticut Cash 5 - 5/35|||',
        FlagName: 'USA'
    },
    26: {
        lotoId: 26,
        name: 'Arizona The Pick - 6/44|Connecticut Classic Loto - 6/44|Arizona The Pick - 6/44|Arizona The Pick - 6/44|',
        FlagName: 'USA'
    },
    27: {
        lotoId: 27,
        name: '|Croatia Loto 6 - 6/45|||',
        FlagName: 'CROATIA'
    },
    28: {
        lotoId: 28,
        name: '|Croatia Loto 7 - 7/39|||',
        FlagName: 'CROATIA'
    },
    29: {
        lotoId: 29,
        name: 'Austria Loto - 6/45|Elvetia Loto - 6/42|Austria Loto - 6/45|Austria Loto - 6/45',
        FlagName: 'AUSTRIA'
    },
    30: {
        lotoId: 30,
        name: '|Europa Euro Millions - 5/50||',
        FlagName: 'INTERNATIONAL'
    },
    31: {
        lotoId: 31,
        name: '|Finlanda Loto - 7/40|||',
        FlagName: 'FINLAND'
    },
    32: {
        lotoId: 32,
        name: '|Florida Fantasy 5 - 5/36|||',
        FlagName: 'USA'
    },
    33: {
        lotoId: 33,
        name: '|Florida Loto - 6/53|||',
        FlagName: 'USA'
    },
    34: {
        lotoId: 34,
        name: '|Franta Loto - 5/49||',
        FlagName: 'FRANCE'
    },
    35: {
        lotoId: 35,
        name: '|Germania Loto - 6/49||',
        FlagName: 'GERMANY'
    },
    36: {
        lotoId: 36,
        name: '|Grecia Loto - 6/49||',
        FlagName: 'GREECE'
    },
    37: {
        lotoId: 37,
        name: '|Hong Kong Loto - 6/49||',
        FlagName: 'CHINA'
    },
    38: {
        lotoId: 38,
        name: 'Arizona The Pick - 6/44|Illinois Loto - 6/52|Arizona The Pick - 6/44|Arizona The Pick - 6/44|',
        FlagName: 'USA'
    },
    39: {
        lotoId: 39,
        name: '|Indiana Hossier Loto - 6/46|||',
        FlagName: 'USA'
    },
    40: {
        lotoId: 40,
        name: '|Irlanda Loto - 6/47||',
        FlagName: 'IRELAND'
    },
    41: {
        lotoId: 41,
        name: `Italia SuperEnalotto - 6/90|Italia SuperEnalotto - 6/90|
            Italia SuperEnalotto - 6/90|Italia SuperEnalotto - 6/90|`,
        FlagName: 'ITALY'
    },
    42: {
        lotoId: 42,
        name: '|Italia Nazionale - 5/90|||',
        FlagName: 'ITALY'
    },
    43: {
        lotoId: 43,
        name: '|Italia Bari - 5/90|||',
        FlagName: 'ITALY'
    },
    44: {
        lotoId: 44,
        name: '|Italia Cagliari - 5/90|||',
        FlagName: 'ITALY'
    },
    45: {
        lotoId: 45,
        name: '|Italia Florenta - 5/90|||',
        FlagName: 'ITALY'
    },
    46: {
        lotoId: 46,
        name: '|Italia Genoa - 5/90|||',
        FlagName: 'ITALY'
    },
    47: {
        lotoId: 47,
        name: '|Italia Milano - 5/90|||',
        FlagName: 'ITALY'
    },
    48: {
        lotoId: 48,
        name: '|Italia Napoli - 5/90|||',
        FlagName: 'ITALY'
    },
    49: {
        lotoId: 49,
        name: '|Italia Palermo - 5/90|||',
        FlagName: 'ITALY'
    },
    50: {
        lotoId: 50,
        name: '|Italia Roma - 5/90|||',
        FlagName: 'ITALY'
    },
    51: {
        lotoId: 51,
        name: '|Italia Torino - 5/90|||',
        FlagName: 'ITALY'
    },
    52: {
        lotoId: 52,
        name: '|Italia Venezia - 5/90|||',
        FlagName: 'ITALY'
    },
    53: {
        lotoId: 53,
        name: '|Letonia Latloto - 5/35||',
        FlagName: 'LATVIA'
    },
    54: {
        lotoId: 54,
        name: '|Marea Britanie Loto - 6/59||',
        FlagName: 'ENGLAND'
    },
    55: {
        lotoId: 55,
        name: '|New Jersey Loto 6 - 6/49|||',
        FlagName: 'USA'
    },
    56: {
        lotoId: 56,
        name: '|New York Take 5 - 5/39|||',
        FlagName: 'USA'
    },
    57: {
        lotoId: 57,
        name: '|Ohio Classic Loto - 6/49|||',
        FlagName: 'USA'
    },
    58: {
        lotoId: 58,
        name: '|Oregon Mega Buck - 6/48|||',
        FlagName: 'USA'
    },
    59: {
        lotoId: 59,
        name: '|Pennsylvania Treas Hunt - 5/30||',
        FlagName: 'USA'
    },
    60: {
        lotoId: 60,
        name: '|Polonia Loto - 6/49||',
        FlagName: 'POLAND'
    },
    61: {
        lotoId: 61,
        name: '|Ontario 49 - 6/49|||',
        FlagName: 'CANADA'
    },
    62: {
        lotoId: 62,
        name: '|Quebec 49 - 6/49|||',
        FlagName: 'CANADA'
    },
    63: {
        lotoId: 63,
        name: '|Singapore Loto - 6/49||',
        FlagName: 'SINGAPORE'
    },
    64: {
        lotoId: 64,
        name: '|Slovenia Loto - 7/39||',
        FlagName: 'SLOVENIA'
    },
    65: {
        lotoId: 65,
        name: '|Spania Bono - 6/49||',
        FlagName: 'SPAIN'
    },
    66: {
        lotoId: 66,
        name: '|Spania Primitiva - 6/49||',
        FlagName: 'SPAIN'
    },
    67: {
        lotoId: 67,
        name: '|Tennessee Cash - 5/35|||',
        FlagName: 'USA'
    },
    68: {
        lotoId: 68,
        name: '|Turcia Loto - 6/49||',
        FlagName: 'TURKEY'
    },
    69: {
        lotoId: 69,
        name: '|Ungaria Loto 5 - 5/90||',
        FlagName: 'HUNGARY'
    },
    70: {
        lotoId: 70,
        name: '|Ungaria Loto 6 - 6/45||',
        FlagName: 'HUNGARY'
    },
    71: {
        lotoId: 71,
        name: '|SUA Mega Millions - 5/70|||',
        FlagName: 'USA'
    },
    72: {
        lotoId: 72,
        name: '|Washington Hit 5 - 5/39|||',
        FlagName: 'USA'
    },
    73: {
        lotoId: 73,
        name: '|Washington Loto - 6/49|||',
        FlagName: 'USA'
    },
    74: {
        lotoId: 74,
        name: '|Wisconsin Badger 5 - 5/31|||',
        FlagName: 'USA'
    },
    75: {
        lotoId: 75,
        name: '|Wisconsin Megabucks - 6/49|||',
        FlagName: 'USA'
    },
    76: {
        lotoId: 76,
        name: 'Belgium Keno - 20/70|Belgia Keno - 20/70|Belgija Keno - 20/70|Belgija Keno - 20/70|',
        FlagName: 'BELGIUM'
    },
    80: {
        lotoId: 80,
        name: 'Germany Keno - 20/70|Germania Keno - 20/70|Nemacka Keno - 20/70|Nemacka Keno - 20/70',
        FlagName: 'GERMANY'
    },
    81: {
        lotoId: 81,
        name: '|Win For Life Numerone - 1/20|||',
        FlagName: 'ITALY'
    },
    83: {
        lotoId: 83,
        name: '|Italia Keno 10e Loto - 20/90|||',
        FlagName: 'ITALY'
    },
    84: {
        lotoId: 84,
        name: 'Slovacia Loto - 5/35|Slovacia Loto - 5/35|Slovacia Loto - 5/35|Slovacia Loto - 5/35|Slovacia Loto - 5/35',
        FlagName: 'SLOVAKIA'
    },
    87: {
        lotoId: 87,
        name: `Slovacia Keno - 20/80|Slovacia Keno - 20/80
            |Slovacia Keno - 20/80|Slovacia Keno - 20/80|Slovacia Keno - 20/80`,
        FlagName: 'SLOVAKIA'
    },
    89: {
        lotoId: 89,
        name: 'Ungaria Keno - 20/80|Ungaria Keno - 20/80|Ungaria Keno - 20/80|Ungaria Keno - 20/80|Ungaria Keno - 20/80',
        FlagName: 'HUNGARY'
    },
    90: {
        lotoId: 90,
        name: '|Austria Loto - 5/90|||',
        FlagName: 'AUSTRIA'
    },
    91: {
        lotoId: 91,
        name: '|Danemarca Loto - 7/36|||',
        FlagName: 'DENMARK'
    },
    92: {
        lotoId: 92,
        name: '|Islanda Loto - 5/40|||',
        FlagName: 'ICELAND'
    },
    93: {
        lotoId: 93,
        name: '|Norvegia Loto - 7/34|||',
        FlagName: 'NORWAY'
    },
    94: {
        lotoId: 94,
        name: '|Turcia SuperLotto - 6/54|||',
        FlagName: 'TURKEY'
    },
    95: {
        lotoId: 95,
        name: '|Polonia Keno - 20/70|||',
        FlagName: 'POLAND'
    }
};

// TODO: Designers should design default flag
const defaultLottoFlag = {
    lotoId: null,
    name: 'Other',
    FlagName: 'NEW'
};

export function getLottoFlagCode(lottoId: number): string | null {
    return flagsMap[lottoId] ? flagsMap[lottoId].FlagName : defaultLottoFlag.FlagName;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/data/lottoFlagsMapping.ts